var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "m9.693 7.564-2.132-2.2A11.763 11.763 0 0 1 12 4.5c5 0 9.27 3.11 11 7.5a11.888 11.888 0 0 1-3.98 5.186l-2.658-2.741a5.002 5.002 0 0 0-6.67-6.881zm-1.425 1.11a5.002 5.002 0 0 0 6.94 7.16l2.255 2.327A11.747 11.747 0 0 1 12 19.5c-5 0-9.27-3.11-11-7.5a11.89 11.89 0 0 1 4.88-5.79zm6.596 4.225-3.673-3.79C11.45 9.04 11.72 9 12 9c1.66 0 3 1.34 3 3 0 .313-.048.615-.136.899m-1.052 1.494A2.99 2.99 0 0 1 12 15c-1.66 0-3-1.34-3-3 0-.715.249-1.37.664-1.886l4.148 4.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M4.27 4 3 5.27 18.73 21.5 20 20.23z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedEye);
export default __webpack_public_path__ + "static/media/ClosedEye.0bc290b4bb181f722c81c15f48bdf188.svg";
export { ForwardRef as ReactComponent };